<template>
  <div
    ref="cell"
    class="grid-view__cell active"
    :class="{
      editing: editing,
      invalid: editing && !valid,
    }"
    @contextmenu="stopContextIfEditing($event)"
  >
    <div v-show="!editing" class="grid-field-social-handle">
      <!-- A static glyph driven by the field's platform. Favicons are
           deliberately NOT fetched: that would hand the user's data to six
           different platforms on every render of every grid row. -->
      <i
        v-if="display.iconClass"
        class="grid-field-social-handle__icon"
        :class="display.iconClass"
        role="img"
        :aria-label="iconLabel"
      ></i>
      <a
        v-if="display.href"
        class="grid-field-social-handle__text"
        :href="display.href"
        target="_blank"
        rel="noopener noreferrer"
        ><SearchHighlightedText :text="display.text" :search-term="searchTerm"
      /></a>
      <span v-else class="grid-field-social-handle__text">
        <SearchHighlightedText :text="display.text" :search-term="searchTerm" />
      </span>
      <!-- A value that did not parse, or that belongs to a different network
           than the field is set to, is shown exactly as it was entered and
           flagged - never hidden, never blanked, never rewritten. -->
      <i
        v-if="warning"
        v-tooltip="warning"
        class="grid-field-social-handle__warning iconoir-warning-triangle"
        role="img"
        :aria-label="warning"
      ></i>
    </div>
    <template v-if="editing">
      <input
        ref="input"
        v-model="copy"
        type="text"
        class="grid-field-text__input"
      />
      <div v-show="!valid" class="grid-view__cell-error align-right">
        {{ error }}
      </div>
    </template>
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import gridFieldInput from '@baserow/modules/database/mixins/gridFieldInput'
import {
  getPlatformName,
  getSocialHandleDisplay,
} from '@baserow/modules/database/utils/socialHandle'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'GridViewFieldSocialHandle',
  components: { SearchHighlightedText },
  mixins: [gridField, gridFieldInput],
  computed: {
    display() {
      // Derived on every render rather than stored, the same way
      // `formatDuration` re-derives a duration from its scalar column.
      return getSocialHandleDisplay(this.value, this.field.platform)
    },
    iconLabel() {
      return this.display.platform
        ? getPlatformName(this.display.platform)
        : this.$t('gridViewFieldSocialHandle.genericPlatform')
    },
    warning() {
      if (this.display.mismatch) {
        return this.$t('gridViewFieldSocialHandle.platformMismatch', {
          detected: getPlatformName(this.display.mismatch),
          configured: getPlatformName(this.field.platform),
        })
      }
      return this.display.unparsed
        ? this.$t('gridViewFieldSocialHandle.unrecognised')
        : null
    },
  },
  methods: {
    afterEdit() {
      this.$nextTick(() => {
        this.$refs.input.focus()
        this.$refs.input.selectionStart = this.$refs.input.selectionEnd = 100000
      })
    },
  },
}
</script>
